import React from 'react';
import { Form, Input as InputAntd } from 'antd';
import cn from 'classnames';
import { normalize } from './utils';
import { InputProps } from './types';
import './style.scss';

export const InputPhone: React.FC<InputProps> = ({ className, name, label, rules, formItemProps, ...props }) => {
  return (
    <div className={cn('form-item_input-phone', className)}>
      <Form.Item
        name={name}
        label={label}
        rules={rules}
        labelCol={{ span: 24 }}
        normalize={normalize}
        {...formItemProps}
      >
        <InputAntd prefix="+1" {...props} />
      </Form.Item>
    </div>
  );
};

export default InputPhone;
